<template>
  <div>
    <div class="mb-4">
      <h5>{{ getBusinessName }}</h5>
    </div>
    <credit-onboarding-steps v-if="showCreditOnboardingSteps" />
    <div v-else>
      <CreditInfoCards :showFallbackCards="false"></CreditInfoCards>
      <DisclaimerCard
        v-if="showExtraDisclaimers"
        :iconSrc="require('@/assets/clipboard-check.svg')"
        :title="$t('message.credit.disclaimer.firstCardTitle')"
        :text="$t('message.credit.disclaimer.firstCardText')"
        :paddingTop="false"
      ></DisclaimerCard>
      <DisclaimerCard
        :iconSrc="require('@/assets/shield-check.svg')"
        :title="$t('message.credit.disclaimer.noAffectScore')"
      ></DisclaimerCard>
      <DisclaimerCard
        :iconSrc="require('@/assets/eye.svg')"
        :title="$t('message.credit.disclaimer.secondCardTitle')"
        :text="privacyDisclaimerText"
      ></DisclaimerCard>
      <DisclaimerCard
        v-if="showExtraDisclaimers"
        :iconSrc="require('@/assets/star.svg')"
        :title="$t('message.credit.disclaimer.thirdCardTitle')"
        :text="`${getBusinessName} ${$t('message.credit.disclaimer.thirdCardText')}`"
      ></DisclaimerCard>
      <div v-if="displayEquifaxBranding">
        <p class="mt-3 font-size-10 color-primary-grey" data-test="equifaxDisclaimer">
          {{ $t('message.credit.disclaimer.equifax') }}
        </p>
      </div>
    </div>
    <div class="start-button-container" :class="{ 'start-button-b54': isSiriusXmInfoRetrieved }">
      <MobialisButton
        data-cy="submit"
        @click="getStart"
        class="start-button mt-3"
        v-av-analytics-cta-interaction="{ elementText: $t('message.common.getStarted'), eventActionResult: 'open' }"
      >
        {{ $t('message.common.getStarted') }}
      </MobialisButton>
      <p
        v-if="showCreditOnboardingSteps"
        class="d-flex justify-content-center equifax-disclaimer-text my-0 mt-1 mb-2"
        data-test="equifaxDisclaimer"
      >
        {{ $t('message.credit.disclaimer.equifax') }}
      </p>
      <p v-else class="d-flex justify-content-center small my-0 mt-1 mb-2" data-test="noAffectScore">
        {{ $t('message.credit.disclaimer.noAffectScore') }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DisclaimerCard from '@/components/DisclaimerCard.vue';
import CreditInfoCards from '@/components/credit/CreditInfoCards.vue';
import { CreditDataSourceCA } from '@/utils/enums';
import CreditOnboardingSteps from '@/components/credit/CreditOnboardingSteps.vue';

export default {
  name: 'Disclaimer',
  components: {
    CreditOnboardingSteps,
    DisclaimerCard,
    CreditInfoCards,
  },
  data() {
    return {
      CreditDataSourceCA,
    };
  },
  async mounted() {
    this.$store.commit('SET_LOADING', false);
    // this experiment should only run for English Canadian users on TD Equifax
    // TODO: remove this when the experiment is over
    if (this.displayEquifaxBranding && this.isTDPrequalEnabled && this.$i18n.locale === 'en_CA') {
      await this.$store.dispatch('setExperimentVariant', 'experiment-credit-onboarding');
    }
  },
  computed: {
    ...mapGetters('business', [
      'getBusinessName',
      'getDefaultCreditDataSourceCA',
      'displayEquifaxBranding',
      'isTDPrequalEnabled',
      'isSiriusXmInfoRetrieved',
    ]),
    showCreditOnboardingSteps() {
      const experiment = this.$store.state.experiments.find(item => item.name === 'experiment-credit-onboarding');
      return experiment.variantSet === 'v2';
    },
    getCreditBureauName() {
      if (this.getDefaultCreditDataSourceCA === CreditDataSourceCA.CREDIT_PLUS) {
        return 'TransUnion';
      }
      if (this.displayEquifaxBranding) {
        return 'Equifax';
      }
      return null;
    },
    isPersonalizedCreditSource() {
      return this.getDefaultCreditDataSourceCA === CreditDataSourceCA.CREDIT_PLUS || this.displayEquifaxBranding;
    },
    showExtraDisclaimers() {
      return !this.isPersonalizedCreditSource;
    },
    privacyDisclaimerText() {
      if (this.isPersonalizedCreditSource && this.getCreditBureauName) {
        return this.$t(`message.credit.application.${this.getCreditBureauName.toLowerCase()}PrivacyDisclaimer`);
      }
      return this.$t('message.credit.disclaimer.secondCardText');
    },
  },
  methods: {
    getStart() {
      this.$router.push('credit-form');
    },
  },
};
</script>

<style lang="scss" scoped>
.start-button-container {
  padding: 0 5%;
  background-color: #fff;
  max-height: 100px;
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  z-index: 1030;
}
.start-button-b54 {
  bottom: 54px;
}
.equifax-disclaimer-text {
  font-size: 10px;
}
</style>
